import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { SortableElement, SortableHandle } from 'react-sortable-hoc';
import { ListGroupItem, Button, Input } from 'reactstrap';
import { MdRemoveCircle } from 'react-icons/md';
import styles from "./List.module.scss";

const DragHandle = SortableHandle(({ index, onIndexChange }) => (
  <div
    className={classNames(
      'rounded ml-3 bg-dark text-light',
      styles.listItemNumber
    )}
  >
    {onIndexChange && (
      <span className="d-block" style={{ padding: '2px 2px 0' }}>
        <Input
          type="tel"
          bsSize="sm"
          dir="ltr"
          className="text-center"
          style={{ height: 24 }}
          placeholder={index}
          onKeyDown={e => {
            if (e.key === 'Enter') {
              onIndexChange({
                oldIndex: index - 1,
                newIndex: Number(e.target.value) - 1
              });
            }
          }}
        />
      </span>
    )}
    {!onIndexChange && index}
  </div>
));

const ListItem = ({
  data,
  index,
  sortable,
  render,
  renderFull,
  itemClassName,
  flexItem = true,
  remove,
  showOnHover,
  onIndexChange
}) => {
  if (sortable) {
    const SortableItem = SortableElement(() => {
      if (renderFull) return (() => (
        <div className={classNames({[itemClassName]: itemClassName})}>
          {renderFull(data)}
        </div>
      ))();
      return (
        <ListGroupItem
          action
          className={classNames(
            `justify-content-start align-items-center flex-shrink-0`,
            {
              [itemClassName]: itemClassName,
              'd-flex': flexItem
            },
            styles.item
          )}
        >
          <DragHandle index={index + 1} onIndexChange={onIndexChange} />
          {render && render(data)}
          {remove && (
            <Button
              type="button"
              color="link"
              className={classNames(
                'mr-auto text-danger',
                {
                  'show-on-hover': showOnHover
                },
                'has-icon'
              )}
              onClick={() => remove(data)}
            >
              <MdRemoveCircle />
            </Button>
          )}
        </ListGroupItem>
      )
    });

    return <SortableItem index={index} />;
  }

  return (
    <ListGroupItem
      action
      className='d-flex justify-content-start align-items-center rtl flex-shrink-0'
    >
      {render && render(data)}
      {remove && (
        <Button
          type="button"
          color="link"
          className={classNames(
            'mr-auto text-danger',
            {
              'show-on-hover': showOnHover
            },
            'has-icon'
          )}
          onClick={() => remove(data)}
        >
          <MdRemoveCircle />
        </Button>
      )}
    </ListGroupItem>
  );
};

export default ListItem;

ListItem.propTypes = {
  data: PropTypes.object,
  index: PropTypes.number,
  sortable: PropTypes.bool,
  render: PropTypes.func,
  itemClassName: PropTypes.string,
  flexItem: PropTypes.bool,
  remove: PropTypes.func,
  onIndexChange: PropTypes.func,
  showOnHover: PropTypes.bool
};
ListItem.defaultProps = {
  data: null,
  index: null,
  sortable: false,
  render: null,
  itemClassName: null,
  flexItem: true,
  remove: null,
  onIndexChange: null,
  showOnHover: false
};
